import { IconButton, Stack, Typography } from '@mui/material';

import FontAwesomeIcon from 'features/common/FontAwesomeIcon';
import { classNames } from 'features/common/utils';

import styles from './NotificationsPanel.module.css';

interface IBreadcrumb {
  name: string;
  handleClose: () => void;
  classes?: string[];
}

export function Breadcrumb({ name, handleClose, classes = [] }: IBreadcrumb) {
  return (
    <Stack
      direction="row"
      alignItems="center"
      className={classNames(styles.breadcrumb, ...classes)}
    >
      <Typography variant="h4" pl="0.5rem">
        {name}
      </Typography>
      <IconButton
        size="small"
        title="Close"
        onClick={handleClose}
        sx={{
          '&:hover': {
            backgroundColor: 'transparent',
          },
        }}
      >
        <FontAwesomeIcon name="xmark" type="sharp-solid" size="0.75rem" />
      </IconButton>
    </Stack>
  );
}
